export const endpoint = {
    base: {
        enum: "/enum",
        uploadFile: "/upload-file",
        city_state: "/state-cities",
        send_otp: "/otp",
        verify_otp: "/otp/verify",
    },
    institute: {
        enum: "/enum",
        detail: "/detail",
        programs: "/programs",
    },
    admissions: {
        enum: "/enum",
        uploadDocument: "/document/upload",
        pendingDocuments: "/pending-documents",
    },
    student: {
        enum: "/enum",
    }
};
